import { isRecord } from '../core/record';

type ConsumeLatestJump = (channelId: string) => boolean;
type JumpToLatest = () => void;

/** Consumes a route-level latest intent after its destination feed is ready. */
export function drainPendingLatestJump(channelId: string | null, consume: ConsumeLatestJump, jumpToLatest: JumpToLatest): boolean {
  if (!channelId || !consume(channelId)) return false;

  jumpToLatest();
  return true;
}

/** Handles a latest intent immediately when its destination feed is already mounted. */
export function handleFeedLatestJumpRequest(
  activeChannelId: string | null,
  detail: unknown,
  consume: ConsumeLatestJump,
  jumpToLatest: JumpToLatest,
): boolean {
  if (!activeChannelId || !isRecord(detail) || String(detail.channelId) !== activeChannelId) return false;
  return drainPendingLatestJump(activeChannelId, consume, jumpToLatest);
}
